import { faWrench } from '@fortawesome/free-solid-svg-icons';
import * as React from 'react';
import { FontAwesomeIcon } from './helpers/FontAwesomeIcon';

export const WrenchIcon = (props: { color?: string }) => {
  return (
    <FontAwesomeIcon icon={faWrench} color={props.color || 'black'} />
  )
}
